module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAAA2ElEQVR4nO3awQ2DMBAAQZJSKYxWkwYiLBTBIjPzBSPEvsx5WQAAAAAAgNm9Rjes6/rZu75t2+4zRutnN/o+76tehN8EiAkQEyAmQEyAmAAAAAAXMw84mXnAzQkQEyAmQEyAmAAxAQAAAC5mHnAy84CbEyAmQEyAmAAxAWICAAAAXGw4D3iaf+cfR9kJxwSICRATICZATICYADEBYgLEBIgJEJv+X1B9NtXZ0JsTICZATICYADEBYgLEpt8HHGUm/DACxASICRATICZATICYADEBYgLEBIh9Ae8lJGvoExr0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/disabled-additions.png
// module id = 1398
// module chunks = 0